import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function CSEHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-716">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/aC1fEz9dqfa56oHxPaP4rk/Coolsculpting.jpg)'
    }} data-id="element-717" />
      <div className="absolute inset-0 bg-black/50" data-id="element-718" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-719">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-720">
          <div className="mb-6" data-id="element-721">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-722">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-723">
                Treatments
              </a>{' '}
              / Body
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-724">
            Be SEEN
          </span>

          <h1 className="text-[32px] sm:text-5xl lg:text-[60px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-725">
            COOLSCULPTING ELITE
          </h1>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8 mt-3" data-id="element-726">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-727">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-728">
              <em data-id="element-729">
                "Everyone has those stubborn areas where no matter how much we
                exercise and try to lose weight, they just won't budge. Let
                science help you!"
              </em>{' '}
              says Dr. Fiona. Let us introduce CoolSculpting Elite!
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-730">
              At Be CLINICAL, we are experts at CoolSculpting techniques and
              treatments! Our CoolSculpting staff all graduated from the
              Allergan CoolSculpting University and we pride ourselves on
              continuing education with advanced training in the best and latest
              methodologies.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-731">
              <em data-id="element-732">
                "Our hard work ensures that you get the best possible results!"
              </em>{' '}
              says Dr. Fiona.{' '}
              <em data-id="element-733">
                "It's one of the reasons we offer CoolSculpting Elite vs.
                traditional CoolSculpting. We think it provides advanced
                benefits and better results."
              </em>
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-734">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}